<div class="flex items-center justify-between px-4 pt-5 pb-3">
  <h1 class="text-primary text-2xl font-bold">
    @if (isCurrentStockMode()) {
      <span i18n="@@stock.currentStock">Current Stock</span>
    } @else {
      <span i18n="@@stock.stockHistory">Stock History</span>
    }
  </h1>

  <div class="flex items-center gap-3">
    <button
      (click)="toggleStockMode()"
      class="border-primary text-primary hover-bg-primary-10 flex cursor-pointer items-center justify-center gap-2 rounded-[8px] border-2 bg-white px-[15px] py-[5px] text-[13px] font-bold transition-all">
      @if (isCurrentStockMode()) {
        <span i18n="@@stock.viewHistory">View History Stock</span>
      } @else {
        <span i18n="@@stock.viewCurrent">View Current Stock</span>
      }
    </button>

    <a
      routerLink="/admin/stock/add-stock"
      class="add-button flex items-center justify-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" />
      </svg>
      <span i18n="@@stock.addStock">Add Stock</span>
    </a>
  </div>
</div>

<div class="mb-4 rounded-2xl px-[16px] pb-[16px]">
  <app-stock-filters
    [(filters)]="filters"
    [(productSearchTerm)]="productSearchTerm"
    [(showProductTitleDropdown)]="showProductTitleDropdown"
    [isCurrentStockMode]="isCurrentStockMode()"
    [suppliers]="suppliers()"
    [stockTypes]="stockTypes()"
    [productTitleLoading]="productTitleLoading()"
    [productTitleResults]="productTitleResults()"
    (productTitleFocus)="onProductTitleFocus()"
    (selectProductTitle)="onSelectProductTitle($event)"
    (searchChange)="onSearchProduct($event)"
    (applyFilters)="applyFilters()"
    (resetFilters)="resetFilters()"
    (toggleSortOrder)="toggleOrder()" />

  <div
    class="overflow-hidden rounded-xl border border-gray-100 bg-white p-4 shadow-sm transition-all"
    [class.min-h-[400px]]="loading() || error() || allStockData().length === 0"
    [class.flex]="loading() || error() || allStockData().length === 0"
    [class.items-center]="loading() || error() || allStockData().length === 0"
    [class.justify-center]="loading() || error() || allStockData().length === 0">
    @if (loading()) {
      <app-loading />
    } @else if (error()) {
      <app-error-data
        title="Failed to load stock data"
        i18n-title="@@stock.errorTitle"
        description="Something went wrong while fetching the data. Please try again."
        i18n-description="@@stock.errorDesc"
        [showRetry]="true"
        (retry)="loadData()" />
    }
    <!-- @else if (allStockData().length === 0) {
        <app-empty-data
          [title]="noDataTitle"
          i18n-title="@@noSubProductsFoundArtitle"
          [description]="noDataSubTitle"
          i18n-description="@@noSubProductsFoundAr"
          />
      }  -->
    @else {
      <div class="w-full overflow-x-auto">
        @if (isCurrentStockMode()) {
          <app-current-stock-table
            [allStockData]="allStockData()"
            [startItem]="startItem()"
            [totalItems]="totalElements()"
            [currentPage]="currentPage()"
            [itemsPerPage]="itemsPerPage"
            [totalPages]="totalPages()"
            [pageNumbers]="getPageNumbers()"
            (previousPage)="previousPage()"
            (nextPage)="nextPage()"
            (goToPage)="goToPage($event)"
            (pageSizeChange)="onPageSizeChange($event)" />
        } @else {
          <app-history-stock-table
            [allStockData]="allStockData()"
            [startItem]="startItem()"
            [totalItems]="totalElements()"
            [currentPage]="currentPage()"
            [itemsPerPage]="itemsPerPage"
            [totalPages]="totalPages()"
            [pageNumbers]="getPageNumbers()"
            (previousPage)="previousPage()"
            (nextPage)="nextPage()"
            (goToPage)="goToPage($event)"
            (pageSizeChange)="onPageSizeChange($event)" />
        }
      </div>
    }
  </div>
</div>
